import { render } from "./PageNoParam.vue?vue&type=template&id=0506e355&ts=true"
import script from "./PageNoParam.vue?vue&type=script&lang=ts"
export * from "./PageNoParam.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Hirofumi\\repository\\suite_totalling\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__